<app-refresh-page
  class="page-loader"
  *ngIf="isLoading$ | async"
></app-refresh-page>

<router-outlet></router-outlet>
